export default function Error403() {
  return (
    <div className="error-container">
      <h1 class="oneline">Доступ закрыт</h1>

      <div className="error-container__buttons">
        <a href="/admin" className="btn btn--dark">На главную</a>
      </div>
    </div>
  );
};
